import { useIntl } from 'react-intl'
import { UrgencyDimensionRowDTO } from '../../../dto/urgencySummary/UrgencySummaryDTO'
import { formatCount, formatMinutes, formatPercent } from '../urgencySummaryFormat'

interface UrgencyDayTemplatesProps {
  /** Las guardias con llegadas ese día (de más a menos llegadas). */
  rows: UrgencyDimensionRowDTO[]
  /** El título del día («Martes 22/09/2026»): lo nombra el aria-label de cada fila. */
  dayTitle: string
  /** Tocar una guardia: abre ese día, en el mismo panel, solo con ella. */
  onSelect: (row: UrgencyDimensionRowDTO) => void
}

/**
 * «Por guardia»: una fila-botón por guardia con llegadas ese día, con su nombre completo (envuelve, no se recorta), sus
 * llegadas y el porcentaje que se retiró sin atención, y a la derecha su espera media. Tocar una fila abre el mismo día
 * filtrado por esa guardia.
 * TODO(design-system): una lista de filas clickeables en un drawer no está en Novarium; se arma como la de Estadísticas de
 * atención (separador, alto holgado, foco teal hacia adentro y una flecha › en --text-2 como indicio).
 */
export default function UrgencyDayTemplates({ rows, dayTitle, onSelect }: UrgencyDayTemplatesProps) {
  const intl = useIntl()
  return (
    <ul className="nv-urg-detail__templates">
      {rows.map((row) => {
        const arrivals = intl.formatMessage(
          { id: 'UrgencySummaryWhereArrivals' },
          { count: row.arrivals, countText: formatCount(intl, row.arrivals) },
        )
        const left = row.leftPercent === null
          ? null
          : intl.formatMessage({ id: 'UrgencySummaryDayTemplateLeft' }, { pct: formatPercent(intl, row.leftPercent) })
        return (
          <li key={row.id}>
            <button
              type="button"
              className="nv-urg-detail__template"
              aria-label={intl.formatMessage({ id: 'UrgencySummaryDayTemplateRowLabel' }, {
                name: row.name,
                day: dayTitle,
                arrivals,
                wait: formatMinutes(intl, row.waitedAvgMinutes),
                left: left === null ? '' : `, ${left}`,
              })}
              onClick={() => onSelect(row)}
            >
              <span className="nv-urg-detail__template-main">
                <span className="nv-urg-detail__template-name">{row.name}</span>
                <span className="nv-urg-detail__meta">{arrivals}</span>
                {left !== null && <span className="nv-urg-detail__meta">{left}</span>}
              </span>
              <span className="nv-urg-detail__big">{formatMinutes(intl, row.waitedAvgMinutes)}</span>
              <i className="pi pi-angle-right" aria-hidden="true" />
            </button>
          </li>
        )
      })}
    </ul>
  )
}
